import { withChartLayout } from 'components/common';
import SLUMSExamination from 'components/features/chart/special-charts/slums-examination/SLUMSExamination';

const SLUMSExaminationPage = withChartLayout('Saint Louis University Mental Status (SLUMS) Examination')(SLUMSExamination);
export default SLUMSExaminationPage;
